import ChangeMethodModal from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/ChangeMethodModal/ChangeMethodModal';
import { withChangeMethodModalProps } from 'viewModel/rwdBasket/changeMethodModal/withChangeMethodModalProps';

export default withChangeMethodModalProps(ChangeMethodModal);
